// Move validations here (previously in utils.js)
export const validateBusinessName = (val) => {
  if (!val) return 'BUSINESS_NAME_REQUIRED';
  return '';
};

export const validateBusinessGstinPan = (val) => {
  if (!val) return 'BUSINESS_GSTINPAN_REQUIRED';
  // Basic GSTIN: 15 chars, PAN: 10 chars, alphanumeric
  if (!/^([A-Z0-9]{15}|[A-Z0-9]{10})$/i.test(val)) return 'BUSINESS_GSTINPAN_INVALID';
  return '';
};

export const validateBusinessAddress = (val) => {
  if (!val) return 'BUSINESS_ADDRESS_REQUIRED';
  return '';
};

export const validateKycStatus = (val) => {
  if (!val) return 'KYC_STATUS_REQUIRED';
  return '';
};

// Validation helpers for profile fields
export const validateName = (val) => {
  if (!val) return 'NAME_REQUIRED';
  return '';
};

export const validateEmail = (val) => {
  if (!val) return 'EMAIL_REQUIRED';
  if (!/^\S+@\S+\.\S+$/.test(val)) return 'EMAIL_INVALID';
  return '';
};

export const validatePhone = (val) => {
  if (!val) return 'PHONE_REQUIRED';
  if (!/^\d{10}$/.test(val)) return 'PHONE_INVALID';
  return '';
};
